module.exports = __webpack_public_path__ + "static/home-dumpster-f0b49c39ee1daf8eac1064411d041f9e.jpg";